export default "__VITE_ASSET__BkW$UzkS__"